import * as _ from 'lodash';

import { window } from '../../globals';

const ORG_HINT_STORAGE_KEY = 'fossa-login-org-hint';

/**
 * Syncs the org hint an OIDC client sent along (`/auth/login?org_hint=<orgId>`)
 * into tab-scoped storage. The stash — not the URL — is what the org pickers
 * read, because a social login round-trips through the OAuth provider and
 * comes back without the original query string. A load WITHOUT a valid hint
 * clears the stash, so a hint is scoped to the login attempt that carried it
 * and can never bleed into a later unhinted login in the same tab — callers
 * must skip the sync on mid-flow loads (a pending social phase) that
 * legitimately arrive hintless. Storage failures (private mode, blocked site
 * data) are ignored.
 *
 * @param {unknown} orgHint - The raw `org_hint` query value from the login URL.
 */
export const syncOrgHintFromQuery = (orgHint: unknown): void => {
  try {
    if (_.isString(orgHint) && /^\d+$/.test(orgHint)) {
      window.sessionStorage.setItem(ORG_HINT_STORAGE_KEY, orgHint);
    } else {
      window.sessionStorage.removeItem(ORG_HINT_STORAGE_KEY);
    }
  } catch {
    // Best-effort: without storage the pickers just show no preselection.
  }
};

export const readOrgHint = (): number | null => {
  try {
    const raw = window.sessionStorage.getItem(ORG_HINT_STORAGE_KEY);
    return raw && /^\d+$/.test(raw) ? Number(raw) : null;
  } catch {
    return null;
  }
};
